/**
 * Created by bszggg on 2021. 08. 31..
 */

import Api from '@/api/Api';

// HelperSzamlazzhu
const HelperSzamlazzhu = {

  // beallitasok
  getBeallitasok: function () {
    const beallitasok = {
      felhasznalo: "",
      jelszo: "",
      szamlaagentkulcs: "",
      eszamla: true,
      szamlaLetoltes: true,
      valaszVerzio: 2,
    };
    return beallitasok;
  },
  // fejlec
  getFejlec: function () {
    const fejlec = {
      keltDatum: "",
      teljesitesDatum: "",
      fizetesiHataridoDatum: "",
      fizmod: "",
      penznem: "HUF",
      szamlaNyelve: "hu",
      megjegyzes: "",
      arfolyamBank: "MNB",
      arfolyam: "0.0",
      rendelesSzam: "",
      dijbekeroSzamlaszam: "",
      elolegszamla: false,
      vegszamla: false,
      helyesbitoszamla: false,
      helyesbitettSzamlaszam: "",
      dijbekero: false,
      szamlaszamElotag: "",

    };
    return fejlec;
  },
  // elado
  getElado: function () {
    const elado = {
      bank: "",
      bankszamlaszam: "",
      emailReplyto: "",
      emailTargy: "",
      emailSzoveg: "",
    };
    return elado;
  },

  // vevo
  getVevo: function () {
    const vevo = {
      nev: "",
      irsz: "",
      telepules: "",
      cim: "",
      email: "",
      sendEmail: false,
      adoszam: "",
      postazasiNev: "",
      postazasiIrsz: "",
      postazasiTelepules: "",
      postazasiCim: "",
      azonosito: "",
      telefonszam: "",
      megjegyzes: "",
    };
    return vevo;
  },

  // fuvarlevel
  getFuvarlevel: function () {
    const fuvarlevel = {
      uticel: "",
      futarSzolgalat: "",
    };
    return fuvarlevel;
  },

  // element
  getElement: function () {
    const element = {
      megnevezes: "",
      mennyiseg: "",
      mennyisegiEgyseg: "",
      nettoEgysegar: "",
      afakulcs: "",
      nettoErtek: "",
      afaErtek: "",
      bruttoErtek: "",
      megjegyzes: ""
    };
    return element;
  },

  getAPIurl: function () {
    return   'https://www.szamlazz.hu/szamla/';
  },

  makeXML: function (beallitasok,fejlec,elado,vevo,fuvarlevel, elements) {
    let strXML = `<?xml version="1.0" encoding="UTF-8"?><xmlszamla xmlns="http://www.szamlazz.hu/xmlszamla" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.szamlazz.hu/xmlszamla https://www.szamlazz.hu/szamla/docs/xsds/agent/xmlszamla.xsd">
    <beallitasok>`;
        strXML += (beallitasok.felhasznalo)?`<felhasznalo>${beallitasok.felhasznalo}</felhasznalo>`:"";
        strXML += (beallitasok.jelszo)?`<jelszo>${beallitasok.jelszo}</jelszo>`:"";
        strXML += (beallitasok.szamlaagentkulcs)?`<szamlaagentkulcs>${beallitasok.szamlaagentkulcs}</szamlaagentkulcs>`:"";
        strXML += `<eszamla>${beallitasok.eszamla}</eszamla>`;
        strXML += `<szamlaLetoltes>${beallitasok.szamlaLetoltes}</szamlaLetoltes>`;
        strXML += `<valaszVerzio>${beallitasok.valaszVerzio}</valaszVerzio>`;
        strXML += `<aggregator></aggregator>`;
    strXML += `</beallitasok>`;
    strXML += `<fejlec>
        <keltDatum>${fejlec.keltDatum}</keltDatum>
        <teljesitesDatum>${fejlec.teljesitesDatum}</teljesitesDatum>
        <fizetesiHataridoDatum>${fejlec.fizetesiHataridoDatum}</fizetesiHataridoDatum>
        <fizmod>${fejlec.fizmod}</fizmod>
        <penznem>${fejlec.penznem}</penznem>
        <szamlaNyelve>${fejlec.szamlaNyelve}</szamlaNyelve>
        <megjegyzes>${fejlec.megjegyzes}</megjegyzes>
        <arfolyamBank>${fejlec.arfolyamBank}</arfolyamBank>
        <arfolyam>${fejlec.arfolyam}</arfolyam>
        <rendelesSzam>${fejlec.rendelesSzam}</rendelesSzam>
        <dijbekeroSzamlaszam>${fejlec.dijbekeroSzamlaszam}</dijbekeroSzamlaszam>
        <elolegszamla>${fejlec.elolegszamla}</elolegszamla>
        <vegszamla>${fejlec.vegszamla}</vegszamla>
        <helyesbitoszamla>${fejlec.helyesbitoszamla}</helyesbitoszamla>
        <helyesbitettSzamlaszam>${fejlec.helyesbitettSzamlaszam}</helyesbitettSzamlaszam>
        <dijbekero>${fejlec.dijbekero}</dijbekero>
        <szamlaszamElotag>${fejlec.szamlaszamElotag}</szamlaszamElotag></fejlec>`;


    strXML += `<elado>
        <bank>${elado.bank}</bank>
        <bankszamlaszam>${elado.bankszamlaszam}</bankszamlaszam>
        <emailReplyto>${elado.emailReplyto}</emailReplyto>
        <emailTargy>${elado.emailTargy}</emailTargy>
        <emailSzoveg>${elado.emailSzoveg}</emailSzoveg></elado>`;


    strXML += `<vevo><nev>${vevo.nev}</nev>
        <irsz>${vevo.irsz}</irsz>
        <telepules>${vevo.telepules}</telepules>
        <cim>${vevo.cim}</cim>
        <email>${vevo.email}</email>
        <sendEmail>${vevo.sendEmail}</sendEmail>
        <adoszam>${vevo.adoszam}</adoszam>
        <postazasiNev>${vevo.postazasiNev}</postazasiNev>
        <postazasiIrsz>${vevo.postazasiIrsz}</postazasiIrsz>
        <postazasiTelepules>${vevo.postazasiTelepules}</postazasiTelepules>
        <postazasiCim>${vevo.postazasiCim}</postazasiCim>
        <azonosito>${vevo.azonosito}</azonosito>
        <telefonszam>${vevo.telefonszam}</telefonszam>
        <megjegyzes>${vevo.megjegyzes}</megjegyzes></vevo>`;
    if (fuvarlevel) {
      strXML += `<fuvarlevel><uticel>${fuvarlevel.uticel}</uticel><futarSzolgalat>${fuvarlevel.futarSzolgalat}</futarSzolgalat></fuvarlevel>`;
      return strXML;
    }
    strXML += `<tetelek>`;
    for (let element of elements){


      strXML += `<tetel>
            <megnevezes>${element.megnevezes}</megnevezes>
            <mennyiseg>${element.mennyiseg}</mennyiseg>
            <mennyisegiEgyseg>${element.mennyisegiEgyseg}</mennyisegiEgyseg>
            <nettoEgysegar>${element.nettoEgysegar}</nettoEgysegar>
            <afakulcs>${element.afakulcs}</afakulcs>
            <nettoErtek>${element.nettoErtek}</nettoErtek>
            <afaErtek>${element.afaErtek}</afaErtek>
            <bruttoErtek>${element.bruttoErtek}</bruttoErtek>
            <megjegyzes>${element.megjegyzes}</megjegyzes>
        </tetel>
`;
    }

    // <tetel>
        //     <!-- item 2, details are same as above -->
        //     <megnevezes>Elado izé 2</megnevezes>
        //     <mennyiseg>2.0</mennyiseg>
        //     <mennyisegiEgyseg>db</mennyisegiEgyseg>
        //     <nettoEgysegar>10000</nettoEgysegar>
        //     <afakulcs>27</afakulcs>
        //     <nettoErtek>20000.0</nettoErtek>
        //     <afaErtek>5400.0</afaErtek>
        //     <bruttoErtek>25400.0</bruttoErtek>
        //     <megjegyzes>lorem ipsum 2</megjegyzes>
        // </tetel>
        strXML += `
    </tetelek>
</xmlszamla>
`;
    return strXML;
  },

  getPack: function (packKey, modul) {
    const packs = [
      {key: '1', value: (modul.$t) ? modul.$t('global.pc') : 'pc'}, // modul.$t('global.money')},
      {key: '2', value: (modul.$t) ? modul.$t('global.pc') : 'pc'},
      {key: '3', value: (modul.$t) ? modul.$t('global.kg') : 'kg'},
      {key: '4', value: (modul.$t) ? modul.$t('global.l') : 'l'},
      {key: '5', value: (modul.$t) ? modul.$t('global.m') : 'm'},
      {key: '6', value: (modul.$t) ? modul.$t('global.pack') : 'pack'},
      {key: '7', value: (modul.$t) ? modul.$t('global.occasion') : 'occasion'},
    ];

    let ret = "";
    Array.prototype.forEach.call(packs, function (e, i) {
      if (Number(e.key) === Number(packKey)) {
        ret = e.value;
      }
    });
    // if (ret === "db") {
    //   ret = 'PIECE';
    // }
    // if (Number(packKey) === Number("1")) {
    //   ret = 'OWN';
    // }
    // if (Number(packKey) === Number("2")) {
    //   ret = 'PIECE';
    // }
    // if (Number(packKey) === Number("3")) {
    //   ret = 'KILOGRAM';
    // }
    // if (Number(packKey) === Number("4")) {
    //   ret = 'LITER';
    // }
    // if (Number(packKey) === Number("5")) {
    //   ret = 'METER';
    // }
    // if (Number(packKey) === Number("6")) {
    //   ret = 'PACK';
    // }
    // if (Number(packKey) === Number("7")) {
    //   ret = 'PIECE';
    // }
    // NAV available:
    // {'PIECE', 'KILOGRAM', 'TON', 'KWH', 'DAY', 'HOUR', 'MINUTE', 'MONTH', 'LITER', 'KILOMETER', 'CUBIC_METER', 'METER', 'LINEAR_METER', 'CARTON', 'PACK', 'OWN'}

    return ret;
  },

  send: function (XMLSting) {

    let parseXml;
    if (window.DOMParser) {
      parseXml = function(xmlStr) {
        return ( new window.DOMParser() ).parseFromString(xmlStr, "text/xml");
      };
    } else if (typeof window.ActiveXObject !== "undefined" && new window.ActiveXObject("Microsoft.XMLDOM")) {
      parseXml = function(xmlStr) {
        const xmlDoc = new window.ActiveXObject("Microsoft.XMLDOM");
        xmlDoc.async = "false";
        xmlDoc.loadXML(xmlStr);
        return xmlDoc;
      };
    } else {
      parseXml = function() { return null; }
    }

    console.log("XMLSting");
    console.log(XMLSting);
    // const requestXML = XMLSting; //parseXml(XMLSting);
    // console.log("requestXML");
    // console.log(requestXML);
    return new Promise((resolve, reject) => {

      var data = new FormData();
      // data.append('file', input.files[0])
      // data.append('user', 'hubot')
      // var xmlString = "<root></root>";


      var parts = [
        new Blob([XMLSting], {type: 'text/xml'}) //,'',new Uint16Array([33])
      ];

// Construct a file
      var file = new File(parts, 'sample.xml', {
        lastModified: new Date(0), // optional - default = now
        type: "text/xml" // optional - default = ''
      });


      var parser = new DOMParser();
      var xmlDoc = parser.parseFromString(XMLSting, "text/xml");
      data.append('action-xmlagentxmlfile',file); //       data.append('action-xmlagentxmlfile',XMLSting); //

      data.append('generate',"Issue invoice");

      data.xml = XMLSting;

      Api.sendSzamlazzHu({data:data}).then(function (e) {
        if (e && e.result === true) {
          console.log(e);
          resolve(e);
        } else {
          console.log("reject e ");
          console.log(e);
          reject(e);
        }
      }, function (err) {
        console.log(err);
        reject(data);
      });

      /*
      fetch(HelperSzamlazzhu.getAPIurl() + "", {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit

        mode: 'no-cors',



        // 'Access-Control-Allow-Origin': '*',
        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
        // 'Access-Control-Allow-Headers': 'X-Requested-With,content-type',
        // 'Access-Control-Allow-Credentials': true,
        headers: {
          // 'Content-Type': 'text/xml',
          // accept: "text/xml",

          // 'Access-Control-Allow-Origin': '*',
          // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
          // 'Access-Control-Allow-Headers': 'X-Requested-With,content-type',
          // 'Access-Control-Allow-Credentials': true,


        },
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *client
        body: data // body data type must match "Content-Type" header
      })

        .then(response => {
          console.log("response:");
          console.log(response);

          return response.text();
        })
        .then(str => {
          console.log("str:");
          console.log(str);
          return (new window.DOMParser()).parseFromString(str, "text/xml");
        })
        .then(datar => {
          console.log("datar:");
          console.log(datar);
          resolve(datar);
          // const resXML = data;
          // try {
          // const dataFromResXML = resXML.getElementsByTagNameNS("*","encodedExchangeToken")[0].childNodes[0].nodeValue;
          // log.info(encodedExchangeToken);
          //   // resolve(dataFromResXML);
          // } catch (e) {
          //   log.info("ERROR - ExchangeToken receive failed")
          //   // reject(data);
          // }
        }, function (data) {
          reject(data);
        });
      //*/
    });
  },


};

export default HelperSzamlazzhu;
